import { render, staticRenderFns } from "./TicketImageViewer.vue?vue&type=template&id=2abed8eb&"
import script from "./TicketImageViewer.vue?vue&type=script&lang=js&"
export * from "./TicketImageViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports